<div *ngIf="showPremium || showBack" class="main-header">
  <i-tabler class="navbar-trigger" name="align-justified" (click)="handleNavbarToggleClick()"></i-tabler>
  <button *ngIf="user && !user.isPremiumUser" class="premium-button" (click)="getPremium()">
    <i-tabler name="diamond"></i-tabler>
    Premium-Upgrade
  </button>
  <div *ngIf="user && user.isPremiumUser"></div>
  <div class="streak-container" (click)="showStreak()">
    <i class="fas fa-fire"></i>
    <span>{{user?.numberOfStreakDays}}</span>
  </div>
</div>

<div *ngIf="false" class="navigational-header">
  <i-tabler *ngIf="showBack" name="arrow-left" (click)="navigateBack()"></i-tabler>
  <i-tabler *ngIf="showActions" class="actions" name="dots-vertical" (click)="actionsClicked()"></i-tabler>
</div>

<app-bottom-dialog [title]="'Dein Streak'" [isVisible]="showStreakWidget" (actionCancelled)="showStreakWidget = false">
  <app-streak [streakNumber]="user?.numberOfStreakDays" [days]="user?.currentWeekActivity"></app-streak>
</app-bottom-dialog>